import React from "react";

import Work from "./Work";
import Skills from "./Skills";

const Resume = () => (
  <section id="resume" >
    <Work />
    <Skills />
  </section>
);

export default Resume;



// WEBPACK FOOTER //
// ./src/components/Resume.js